/* eslint-disable */
if (!Object.entries) {
  Object.entries = (obj) => {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);

    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}
/* eslint-enable */

const Map = require('es6-map');

const durations = {
  welcome: 3000,
  guess: 1250,
};

const durationMap = new Map(Object.entries(durations));
const getTime = type => durationMap.get(type);

const helpers = {
  time: getTime,
};

export default helpers;



// WEBPACK FOOTER //
// ./app/js/helpers/notifications.js